import { servicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '../constants';

export function useEnvHealthCampaigns(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  enabled = true,
) {
  return servicesQuery.getEnvHealthCampaigns.useQuery({
    queryKey: ['env-health-campaigns', workspaceId, simulate],
    queryData: { params: { environment_id: workspaceId }, query: { simulate } },
    refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
    enabled: workspaceId > 0 && enabled,
  });
}
